import { Banner } from '@servicetitan/design-system';
import { useDependencies } from '@servicetitan/react-ioc';
import classnames from 'classnames';
import { observer } from 'mobx-react';
import { FC, ReactNode, useEffect } from 'react';
import { LoadState, SubscriptionStore } from '../../stores/subscription.store';
import { ErrorPage } from '../error-page/error-page';
import { PageFooterAnchored } from '../page-footer/page-footer';
import * as Styles from './page-wrapper.module.less';
import { useSearchParams } from 'react-router-dom';
import { SubscriptionOptions } from '../../enums/subscription-options';

export const PageWrapper: FC<{ children: ReactNode }> = observer(({ children }) => {
    const [marketingStore] = useDependencies(SubscriptionStore);
    const [searchParams] = useSearchParams();

    useEffect(() => {
        const validate = async () => {
            const payload = searchParams.get('payload')!;
            const sign = searchParams.get('sign')!;
            const preferencesParam = searchParams.get('preferences');
            if (preferencesParam) {
                const preferences = JSON.parse(preferencesParam) as SubscriptionOptions[];
                marketingStore.setCurrentPreferences(preferences);
            }

            await marketingStore.validatePayload(payload, sign);
        };
        validate().catch();
    }, [marketingStore, searchParams]);

    return marketingStore.state === LoadState.Loaded ? (
        <div className={classnames(Styles.container, 'qa-page-container-div')}>
            {marketingStore.submitted && (
                <Banner
                    status="success"
                    icon
                    title="Subscriptions Updated"
                    onClose={() => marketingStore.setSubmitted(false)}
                    className="m-t-2 qa-subscription-update-success-banner"
                >
                    {marketingStore.sentUnsubscribe
                        ? 'You will no longer receive emails from us.'
                        : 'Your subscriptions have been updated.'}
                </Banner>
            )}
            {children}
            <PageFooterAnchored />
        </div>
    ) : marketingStore.state === LoadState.Error ? (
        <ErrorPage type="not-found" />
    ) : null;
});
